<template>
    <div class="mt-3 grid grid-cols-1 row-gap-2 col-gap-4 sm:grid-cols-12">
        <h2 class="w-full col-span-12 pb-2 border-b-2 border-charcoal-900 text-left font-medium text-charcoal-900">
            Tasks
            <button type="button"
                class="float-right text-xs py-1 px-3 bg-default-500 text-white"
                @click="add()"
            >
                <font-awesome-icon class="text-sm mr-2 text-white" :icon="['fal', 'plus']"/>
                New Task
            </button>
        </h2>
        <pro-table
            :static-data="filteredTasks"
            resource="tasks"
            prefix="/"
            :fields="fields.tasks"
            :limit="100"
            ref="datatable"
            class="px-0 sm:col-span-12"
            @action="actionHandler"
            table-class="text-xs"
            sort="due_date"
            direction="ASC"
            delete-label="subject"
            :pagination="false"
            :redirect="true"
            :actions="actions.tasks"
            :permissions="true"
        ></pro-table>
        <task-form-modal v-if="showTaskFormModal"
            :task="selectedTask"
            :view="selectedView"
            :model="model"
            :id="id"
            @close="showTaskFormModal = false"
            @saved="taskSaved"
            @updated="taskUpdated" />
    </div>
</template>

<script>
    import axios from "axios";
    import TaskFormModal from "@/components/modals/TaskFormModal";
    
    export default {
        name: "Tasks",
        components: {
            TaskFormModal            
        },
        props: {
            tasks: { type: Array, default: () => [], required: false },
            model: { type: String, required: true },
            id: { required: true }
        },
        data: function () {
            return {
                note: '',
                selectedItem: {},
                selectedIndex: null,
                selectedTask: null,
                selectedView: null,
                showTaskFormModal: false,                
                search: '',
                fields: {
                    tasks: [
                        {
                            name: 'Subject',
                            column: 'subject',
                            sortCol: 'subject',
                            columnClass: 'no-wrap'
                        },
                        {
                            name: 'Assignee',
                            column: 'assignee.name',
                        },
                        {
                            name: 'Type',
                            column: 'type.name',
                        },
                        {
                            name: 'Priority',
                            column: 'priority.name',
                        },
                        {
                            name: 'Status',
                            column: 'status.name',
                        },
                        {
                            name: 'Due Date',
                            date: true,
                            format: 'MMMM Do YYYY',
                            column: 'due_date',
                        },
                    ]
                },
                actions: {
                    tasks: {
                        display: true,
                        class: ['text-center'],
                        options: [
                            { label: 'View', method: 'view', icon: 'eye', iconClass: 'text-gray-600', type: 'method', tooltip: 'View', permissions: 'tasks.show' },
                            { label: 'Edit', method: 'edit', icon: 'edit', iconClass: 'text-gray-400', type: 'method', tooltip: 'Edit', permissions: 'tasks.edit' },
                            { label: 'Delete', method: 'destroy', icon: 'trash-alt', iconClass: 'text-gray-500', type: 'method', tooltip: 'Delete Task', permissions: 'tasks.destroy' },
                        ]
                    }
                }
            }
        },
        methods: {
            methodHandler: function (method) {
                this[method]();
            },
            actionHandler: function (data) {
                this[data.method](data);
            },
            add(){
                this.selectedView = 'New';
                this.selectedTask = null;
                this.showTaskFormModal = true;
            },
            view(task){
                this.selectedView = 'View';
                this.selectedTask = task.item;
                this.showTaskFormModal = true;
            },
            edit(task){
                this.selectedView = 'Edit';
                this.selectedTask = task.item;
                this.showTaskFormModal = true;
            },
            destroy(item, index){
                this.$store.commit('TOGGLE_BACKDROP', {open: true});

                axios.delete(process.env.VUE_APP_API_URL + '/tasks/'+item.item.id, {
                    params: {
                        model: this.model,
                        id: this.id
                    }
                }).then(response => {
                    let message;

                    if (response.data.success){
                        this.tasks.forEach((task, index) => {
                            if (task.id === item.item.id){
                                this.tasks.splice(index, 1);
                            }
                        });

                        this.$store.commit('TOGGLE_BACKDROP', {open: false});

                        if (response.data.message){
                            message = response.data.message;
                        } else {
                            message = 'Successfully Deleted Record!';
                        }

                        this.$notify({
                            group: 'main',
                            position: 'top center',
                            type: 'success',
                            title: 'Success',
                            text: message,
                            duration: 10000,
                            speed: 1000
                        });
                    }
                }).catch((error) => {
                    this.$store.commit('TOGGLE_BACKDROP', {open: false});

                    this.$notify({
                        group: 'main',
                        position: 'bottom right',
                        type: 'error',
                        title: 'Error',
                        text: error.message,
                        duration: 5000
                    });
                });
            },
            taskSaved(payload){
                this.tasks.push(payload);
                this.showTaskFormModal = false;
            },
            taskUpdated(payload){
                this.tasks.forEach((task, index) => {
                    if (task.id === payload.id){
                        this.tasks.splice(index, 1);
                    }
                });

                this.$nextTick(() => {
                    this.tasks.push(payload);
                });

                this.showTaskFormModal = false;
            },
        },
        computed: {
            filteredTasks(){
                return this.tasks.slice().sort((a, b) => new Date(a.due_date) - new Date(b.due_date));
            }
        }
    }
</script>

<style scoped>
    #tasks div:last-child .task-container {
        border: 0!important;
    }
</style>
